package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_09_01_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-09-01")
@Composable
public fun Log_2023_09_01(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Top Secret Counsel",
        ogTitle = "Top Secret Counsel",
        date = LocalDate(2_023, 9, 1),
        ogDescription = "The heroes meet with city leadership to discuss the alignment between Sylus and Lalia and a new shard in Zedj.",
        ogImage = "ai/2023-09-01.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-37", dateString = "Newgrowth 37")
        Log_2023_09_01_Day_1()
    }
}
